import gql from 'graphql-tag';

export const payOrder = gql`
  mutation payOrder(
    $code: String!
    $orderId: String!
    $transactionId: String!
    $email: String!
    $payMethod: String!
    $brand: String!
    $message: String!
  ) {
    payOrder(
      pay: {
        code: $code
        orderId: $orderId
        transactionId: $transactionId
        email: $email
        payMethod: $payMethod
        brand: $brand
        message: $message
      }
    ) {
      message
    }
  }
`;
